import { Skeleton, Typography, TypographyProps } from '@mui/material'
import { theme } from 'theme'

export interface TypoletonProps extends TypographyProps {
  data?: any
  prefix?: string
  suffix?: string
  sksize?: 'sm' | 'md' | 'lg' | 'full'
}

const Typoleton = (props: TypoletonProps) => {
  const { data, prefix, suffix, sksize } = props
  const skWidth = {
    sm: '50px',
    md: '80px',
    lg: '120px',
    full: '100%',
  }
  const noSpaceList = ['$', '%']
  const p = prefix && (noSpaceList.includes(prefix) ? prefix : ` ${prefix}`)
  const s = suffix && (noSpaceList.includes(suffix) ? suffix : ` ${suffix}`)

  if (data || !isNaN(data)) {
    return (
      <Typography {...props}>
        {p}
        {data}
        {s}
      </Typography>
    )
  } else if (props.variant !== 'inherit') {
    return (
      <Skeleton
        height={theme.typography[props.variant || 'body1'].lineHeight}
        width={skWidth[sksize || 'full']}
      />
    )
  } else {
    return <Skeleton />
  }
}

export default Typoleton
